"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Tabs_1 = __importDefault(require("@mui/material/Tabs"));
var Tab_1 = __importDefault(require("@mui/material/Tab"));
var Box_1 = __importDefault(require("@mui/material/Box"));
function ItemsSlide(_a) {
    var listItems = _a.listItems, value = _a.value, handleChange = _a.handleChange;
    return ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ sx: { borderBottom: 1, borderColor: 'transparent' } }, { children: (0, jsx_runtime_1.jsx)(Tabs_1.default, __assign({ value: value, onChange: handleChange, "aria-label": "Slide Item Tab", sx: {
                height: '9rem',
                '& .MuiTabs-indicator': {
                    backgroundColor: 'text.secondary',
                    height: '9rem',
                    zIndex: -1,
                    borderRadius: '10px',
                },
            } }, { children: listItems.map(function (item) {
                return ((0, jsx_runtime_1.jsx)(Tab_1.default, { label: item.title, icon: item.icon, sx: {
                        color: 'text.primary',
                        textTransform: 'none',
                        '&.Mui-selected': {
                            color: 'background.default',
                            fontWeight: 'bold',
                        },
                    } }));
            }) })) })));
}
exports.default = ItemsSlide;
//# sourceMappingURL=ItemsSlide.js.map